// extracted by mini-css-extract-plugin
module.exports = {"navBar":"NavBar_navBar__d80L8","navItems":"NavBar_navItems__FLU0x","simpoButton":"NavBar_simpoButton__2fny-"};